import { render, staticRenderFns } from "./customerChart.vue?vue&type=template&id=835b8944"
import script from "./customerChart.vue?vue&type=script&lang=js"
export * from "./customerChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports